// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 로그관리 - 사용자관리 디자인 기준 */

.lm-section {
  width: 100%;
  min-width: 0;
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}

.lm-toolbar {
  margin: 0;
}

.lm-search {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.lm-search input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  height: 41px;
  padding: 0 12px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  color: #34465b;
  font-size: 13px;
  box-sizing: border-box;
}

.lm-search input:focus {
  outline: 2px solid #90c7ff;
  outline-offset: 1px;
}

.lm-search button {
  height: 41px;
  padding: 8px 16px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  color: #34465b;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.lm-search button:hover {
  background: #edf5ff;
}

.lm-table-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin: 25px 0 12px;
  font-size: 14px;
}

.lm-table-top strong {
  font-weight: 700;
}

.lm-table-top span {
  font-size: 12px;
  color: #8a98a8;
}

.lm-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.lm-table {
  width: 100%;
  min-width: 850px;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 12px;
  text-align: center;
  color: #344054;
}

.lm-table th {
  padding: 14px 9px;
  border-top: 2px solid #2196f3;
  background: #f1f5fa;
  color: #3b4c62;
  font-weight: 700;
  white-space: nowrap;
}

.lm-table td {
  padding: 13px 9px;
  border-bottom: 1px solid #e8edf3;
  text-align: center;
  vertical-align: middle;
  overflow-wrap: normal;
}

.lm-table tbody tr:hover {
  background: #f1f8ff;
}

.lm-table td.lm-content-cell {
  text-align: left;
  line-height: normal;
  word-break: keep-all;
}

.lm-table td.lm-date {
  white-space: nowrap;
  color: #58697f;
}

.lm-table td.lm-empty {
  padding: 45px 9px;
  color: #8a98a8;
}

.lm-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  color: #8090a1;
  font-size: 12px;
}

.lm-pagination {
  display: flex;
  align-items: center;
  gap: 5px;
}

.lm-pagination button {
  min-width: 32px;
  padding: 7px 10px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  color: #34465b;
  font-size: 12px;
  cursor: pointer;
}

.lm-pagination button:hover:not(:disabled) {
  background: #edf5ff;
}

.lm-pagination button.active {
  background: #168ff0;
  border-color: #168ff0;
  color: #fff;
}

.lm-pagination button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .lm-table-top {
    flex-wrap: wrap;
  }

  .lm-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* 사용자관리 테이블의 실제 브라우저 적용값 */
.log-management-layout .lm-table {
  font-family: 'Malgun Gothic', Arial, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 15px;
}

.log-management-layout .lm-table th {
  padding: 12px 9px;
  font-size: 15px;
  font-weight: 700;
  line-height: 15px;
}

.log-management-layout .lm-table td {
  height: 48px;
  padding: 10px 9px;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 400;
  line-height: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/log/LogManagement.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* 로그관리 - 사용자관리 디자인 기준 */\n\n.lm-section {\n  width: 100%;\n  min-width: 0;\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n\n.lm-toolbar {\n  margin: 0;\n}\n\n.lm-search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.lm-search input {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  height: 41px;\n  padding: 0 12px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  color: #34465b;\n  font-size: 13px;\n  box-sizing: border-box;\n}\n\n.lm-search input:focus {\n  outline: 2px solid #90c7ff;\n  outline-offset: 1px;\n}\n\n.lm-search button {\n  height: 41px;\n  padding: 8px 16px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  color: #34465b;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.lm-search button:hover {\n  background: #edf5ff;\n}\n\n.lm-table-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin: 25px 0 12px;\n  font-size: 14px;\n}\n\n.lm-table-top strong {\n  font-weight: 700;\n}\n\n.lm-table-top span {\n  font-size: 12px;\n  color: #8a98a8;\n}\n\n.lm-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.lm-table {\n  width: 100%;\n  min-width: 850px;\n  border-collapse: collapse;\n  table-layout: auto;\n  font-size: 12px;\n  text-align: center;\n  color: #344054;\n}\n\n.lm-table th {\n  padding: 14px 9px;\n  border-top: 2px solid #2196f3;\n  background: #f1f5fa;\n  color: #3b4c62;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.lm-table td {\n  padding: 13px 9px;\n  border-bottom: 1px solid #e8edf3;\n  text-align: center;\n  vertical-align: middle;\n  overflow-wrap: normal;\n}\n\n.lm-table tbody tr:hover {\n  background: #f1f8ff;\n}\n\n.lm-table td.lm-content-cell {\n  text-align: left;\n  line-height: normal;\n  word-break: keep-all;\n}\n\n.lm-table td.lm-date {\n  white-space: nowrap;\n  color: #58697f;\n}\n\n.lm-table td.lm-empty {\n  padding: 45px 9px;\n  color: #8a98a8;\n}\n\n.lm-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n  color: #8090a1;\n  font-size: 12px;\n}\n\n.lm-pagination {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.lm-pagination button {\n  min-width: 32px;\n  padding: 7px 10px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  color: #34465b;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.lm-pagination button:hover:not(:disabled) {\n  background: #edf5ff;\n}\n\n.lm-pagination button.active {\n  background: #168ff0;\n  border-color: #168ff0;\n  color: #fff;\n}\n\n.lm-pagination button:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .lm-table-top {\n    flex-wrap: wrap;\n  }\n\n  .lm-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n/* 사용자관리 테이블의 실제 브라우저 적용값 */\n.log-management-layout .lm-table {\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 15px;\n}\n\n.log-management-layout .lm-table th {\n  padding: 12px 9px;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 15px;\n}\n\n.log-management-layout .lm-table td {\n  height: 48px;\n  padding: 10px 9px;\n  box-sizing: border-box;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
